// @ts-nocheck

import styled from 'styled-components';

import { isLibrary } from '../../lib/useragent';

export const MainLayout = styled.div`
  padding: 20px 20px 60px 20px;
  min-width: ${!isLibrary ? '1024px' : '860px'};
`;
